import { UserSelfcare } from '../types'

export const decodeUserSelfcare = (userSelfcare: UserSelfcare | null) => {
  //   const userBox = userSelfcare?.products.find(
  //     (p) =>
  //       (p.type === 'A' && (p.subType === '01' || p.subType === '20')) ||
  //       (p.type === 'I' && p.subType === '05')
  //   )
  if (!userSelfcare) {
    return {
      alias: '',
      commercialOffer: '',
      contact: '',
    }
  }
  const telephone = userSelfcare?.products.find(
    (p) => p.type === 'A' && (p.subType === '01' || p.subType === '20')
  )

  return {
    alias: userSelfcare?.aliasSelfcare,
    commercialOffer: userSelfcare?.commercialOffer,
    contact: telephone?.number,
  }
}
